export default{
    apiUrl: process.env.NODE_ENV === 'production' ? '' : 'https://localhost:44390/'
}